var Backbone, FAQHomeModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

FAQHomeModel = (function(superClass) {
  extend(FAQHomeModel, superClass);

  function FAQHomeModel() {
    return FAQHomeModel.__super__.constructor.apply(this, arguments);
  }

  FAQHomeModel.prototype.initialize = function() {
    return this.url = window.FAQBASEURL + "/home?should_display_cms_content=" + experiments.shouldDisplayCMSContentForUS;
  };

  return FAQHomeModel;

})(Backbone.Model);

module.exports = FAQHomeModel;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL2ZhcS9mcm9udGVuZC9tb2RlbHMvaG9tZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvZmFxL2Zyb250ZW5kL21vZGVscy9ob21lLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHNCQUFBO0VBQUE7OztBQUFBLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFFTDs7Ozs7Ozt5QkFDSixVQUFBLEdBQVksU0FBQTtXQUNWLElBQUMsQ0FBQSxHQUFELEdBQVUsTUFBTSxDQUFDLFVBQVIsR0FBbUIsbUNBQW5CLEdBQXNELFdBQVcsQ0FBQztFQURqRTs7OztHQURhLFFBQVEsQ0FBQzs7QUFJcEMsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
